export default {
  linkMixin: require('../mixins/linkMixin')
};
